/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Application_Phase_Toggle_LabelInputs */

const en_admin_application_phase_toggle_label = /** @type {(inputs: Admin_Application_Phase_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application phase for candidates open`)
};

const de_admin_application_phase_toggle_label = /** @type {(inputs: Admin_Application_Phase_Toggle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungsphase für Bewerber:innen geöffnet`)
};

/**
* | output |
* | --- |
* | "Application phase for candidates open" |
*
* @param {Admin_Application_Phase_Toggle_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_application_phase_toggle_label = /** @type {((inputs?: Admin_Application_Phase_Toggle_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Application_Phase_Toggle_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_application_phase_toggle_label(inputs)
	return en_admin_application_phase_toggle_label(inputs)
});